import React from 'react';

import { Icon, Modal, ModalSize } from '@column/column-ui-kit';

import { NotificationList } from '~/components';
import { SetupDeviceMFA } from '~/lib/authn';
import { Inner } from '~/styles';

interface Props {
  onClose: () => void;
  onSuccess: () => void;
  open: boolean;
}

export const SetupMfaTotpModal: React.FC<Props> = ({ onClose, onSuccess, open }) => {
  return (
    <Modal onClose={onClose} isOpen={open} size={ModalSize.Medium}>
      <Modal.IconCircle type="primary">
        <Icon.Key />
      </Modal.IconCircle>

      <Modal.Content>
        <Modal.Headline fullWidth align="center">
          Setup Authenticator App
        </Modal.Headline>

        <NotificationList display="popup" />

        <Inner p={0} pb={24}>
          <SetupDeviceMFA
            enabled={open}
            onSuccess={onSuccess}
            errorNotificationDisplay="popup"
            successNotificationDisplay="global"
          />
        </Inner>
      </Modal.Content>
    </Modal>
  );
};
